// "3D-Neigung" of the image look (effect profile, image block): the image leans towards the mouse and a soft reflection
// follows it (scss/components/media/_image-styles.scss, .figure--hover-tilt). Only with a mouse, never with reduced motion.
const MAX_TILT = 8;

export default function initImageTilt() {
    const pointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const boxes = document.querySelectorAll('.figure--hover-tilt .figure-media');
    if (!boxes.length || !pointer.matches || reduced.matches) {
        return;
    }

    boxes.forEach((box) => {
        let frame = 0;
        box.addEventListener('pointermove', (event) => {
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(() => {
                const rect = box.getBoundingClientRect();
                const x = (event.clientX - rect.left) / rect.width;
                const y = (event.clientY - rect.top) / rect.height;
                box.classList.add('is-tilting');
                box.style.setProperty('--tilt-x', `${((0.5 - y) * 2 * MAX_TILT).toFixed(2)}deg`);
                box.style.setProperty('--tilt-y', `${((x - 0.5) * 2 * MAX_TILT).toFixed(2)}deg`);
                box.style.setProperty('--glare-x', `${(x * 100).toFixed(1)}%`);
                box.style.setProperty('--glare-y', `${(y * 100).toFixed(1)}%`);
            });
        });
        box.addEventListener('pointerleave', () => {
            cancelAnimationFrame(frame);
            box.classList.remove('is-tilting');
            box.style.setProperty('--tilt-x', '0deg');
            box.style.setProperty('--tilt-y', '0deg');
        });
    });
}
